class Utils {
  daysBetween(d1, d2) {
    return (d1.getTime() - d2.getTime()) / (1000 * 60 * 60 * 24);
  }
}

export const DateUtils = new Utils();



// WEBPACK FOOTER //
// ./src/lib/services/dateUtils.js